import CumulDashboard from "@mapmycustomers/shared/types/cumul/CumulDashboard";

const isDashboardPinned = (
  pinnedDashboardIds: CumulDashboard["id"][],
  dashboardId?: CumulDashboard["id"]
) => {
  return pinnedDashboardIds.some((id) => id === dashboardId);
};

export default isDashboardPinned;
